// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Paper from "elevate-ui/Paper";
import Typography from "elevate-ui/Typography";

import { withGlobalContext } from "../common/GlobalContext";
import { withSellerLeadContext } from "../common/SellerLeadContext";
import Copyright from "./Copyright";
import SellerPage1 from "./SellerPage1";
import SellerPage2 from "./SellerPage2";
import SellerPage3 from "./SellerPage3";
import SellerPageThankYou from "./SellerPageThankYou";
import SellerLeadEmailConfirmation from "./SellerLeadEmailConfirmation";

type $Props = {
  classes: Object,
  page: string,
  city: string,
  homepageSearchHeroImage: string,
};

class LayoutSellerLead extends React.Component<$Props> {
  props: $Props;
  render() {
    const { classes, city } = this.props;
    let { page } = this.props;
    if (page === "") {
      page = "sellerPage1";
    }
    return (
      <div className={classNames(classes.root)}>
        <div className={classes.body}>
          <Paper className={classes.paper} withPadding={false}>
            <div
              className={classNames(
                classes.heroPhoto,
                page !== "sellerPage1" && page !== "sellerPageEmailConfirmation"
                  ? classes.darken
                  : null
              )}
            >
              {page === "sellerPageThankyou" && <SellerPageThankYou />}
              {page === "sellerPage3" && <SellerPage3 />}
              {page === "sellerPage2" && <SellerPage2 />}
              {page === "sellerPage1" && <SellerPage1 />}
              {page === "sellerPageEmailConfirmation" && (
                <SellerLeadEmailConfirmation />
              )}
            </div>

            {page !== "sellerPageThankyou" && (
              <div className={classes.textWapper}>
                <Paper className={classes.paper} withPadding="false">
                  <Typography
                    type="heading3"
                    className={classNames(
                      classes.textContent,
                      classes.subTitleLayout
                    )}
                  >
                    The Truth About {city} Home Values
                  </Typography>

                  <Typography
                    type="body"
                    className={classNames(
                      classes.textContent,
                      classes.subBodyLayout
                    )}
                  >
                    {city} has such a fast-moving vibrant real estate market,
                    that relying on an incorrect analysis can be a huge costly
                    mistake.
                  </Typography>

                  <Typography
                    type="body"
                    className={classNames(
                      classes.textContent,
                      classes.subBodyLayout
                    )}
                  >
                    Whether you're interested in selling or re-financing your
                    own home, or you need to know the value of a home you're
                    considering for purchase, this site can give you the
                    accurate valuation you need.
                  </Typography>

                  <Typography
                    type="body"
                    className={classNames(
                      classes.textContent,
                      classes.subBodyLayout
                    )}
                  >
                    Many real estate websites use computer generated 'estimates'
                    based on broad trends and outdated data. In contrast, our
                    valuation is based on live up to date local information
                    using the same data local real estate agents use.
                  </Typography>
                  <div className={classes["copyright-container"]}>
                    <Copyright />
                  </div>
                </Paper>
              </div>
            )}
          </Paper>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    "& input::placeholder": {
      color: "rgb(46, 46, 53)",
    },
    fontFamily: "Tahoma, Geneva, sans-serif !important",
    WebkitFontSmoothing: "auto",
  },
  body: { boxShadow: theme.shadows[2] },
  heroPhoto: {
    width: "100%",
    minHeight: "721px",
    display: "flex",
    position: "relative",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    background: (props) =>
      `url(${props.homepageSearchHeroImage}) center/cover no-repeat`,
  },
  darken: {
    background: (props) =>
      `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(${
        props.homepageSearchHeroImage
      }) center/cover no-repeat`,
  },
  textWapper: {
    flex: 1,
  },
  textContent: {
    maxWidth: "1000px",
    lineHeight: "1.2",
    margin: "0 auto",
  },
  subTitleLayout: {
    paddingTop: `${theme.spacing.unit * 1.5}px`,
    paddingBottom: `${theme.spacing.unit * 1.5}px`,
    fontSize: "24px",
    fontWeight: "400",
  },
  subBodyLayout: {
    paddingBottom: `${theme.spacing.unit * 1.5}px`,
    fontSize: "14px",
  },
  footer: { textAlign: "right" },
  paper: {
    display: "flex",
    "flex-direction": "column",
    height: "100%",
  },
  "copyright-container": {
    width: "100%",
    "max-width": "1000px",
    margin: "auto auto 0 auto",
  },
});

export default withGlobalContext(
  withSellerLeadContext(withStyles(styles)(LayoutSellerLead))
);
